import { createApi } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import {
  CreatePedidoOracaoDto,
  IPedidoOracao,
} from "@/interfaces/pedido-oracao.interface";

const pedidosOracaoPublicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const { baseQueryWithReauth } = await import("@/lib/api");
  return baseQueryWithReauth(args, api, extraOptions);
};

// API para pedidos de oração públicos (sem autenticação)
export const pedidosOracaoPublicAPI = createApi({
  reducerPath: "pedidosOracaoPublicAPI",
  baseQuery: pedidosOracaoPublicBaseQuery,
  tagTypes: ["PedidosOracaoPublic"],
  endpoints: (builder) => ({
    createPedidoOracao: builder.mutation<IPedidoOracao, CreatePedidoOracaoDto>({
      query: (body) => ({
        url: `/pedidos-oracao`,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        "PedidosOracaoPublic",
        { type: "PedidosOracaoPublic", id: "PAGINATED" },
        { type: "PedidosOracaoPublic", id: "ULTIMOS" },
        { type: "PedidosOracaoPublic", id: "RESUMO" },
        { type: "PedidosOracaoPublic", id: "LIST" },
      ],
    }),
    getPedidosOracaoPublic: builder.query<IPedidoOracao[], void>({
      query: () => ({
        url: `/pedidos-oracao/public`,
        method: "GET",
      }),
      providesTags: ["PedidosOracaoPublic"],
    }),
  }),
});

export const { useCreatePedidoOracaoMutation, useGetPedidosOracaoPublicQuery } =
  pedidosOracaoPublicAPI;
